import {
    EmployeeNodeModel,
    UpdateAndDeleteAdditionalsModalInfo,
} from '../../models';

export const UPDATE_AND_DELETE_ADDITIONALS_MODAL_INFO_EMPTY: UpdateAndDeleteAdditionalsModalInfo =
    {
        initDate: '',
        lastDate: '',
        employee: {} as EmployeeNodeModel[],
        additionals: [[]],
        additionalsCopy: [[]],
    };
